var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMagnifyingGlassDocument = function SvgMagnifyingGlassDocument(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E2E2E2",
    d: "M10.25 6.5v32c0 7.46 6.04 13.5 13.5 13.5 0 7.45 6.04 13.5 13.5 13.5h18v-59z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "M25.548 50.08h-6.34c-1.83 0-3.66-.7-5.06-2.1l13.5 13.5c-1.4-1.4-2.1-3.23-2.1-5.06z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF773D",
    d: "m66.502 55.32-12.85-12.85c4.62-6.17 4.14-14.95-1.47-20.55a15.7 15.7 0 0 0-11.14-4.61c-4.03 0-8.06 1.54-11.14 4.61-6.15 6.15-6.15 16.12 0 22.27 3.08 3.08 7.11 4.61 11.14 4.61 3.32 0 6.63-1.06 9.42-3.15l12.85 12.85 3.18-3.18zM41.042 44.3c-3.01 0-5.83-1.17-7.95-3.29-4.39-4.39-4.39-11.52 0-15.91a11.2 11.2 0 0 1 7.95-3.3c3 0 5.83 1.17 7.95 3.3 2.13 2.12 3.3 4.95 3.3 7.95s-1.17 5.83-3.3 7.96a11.2 11.2 0 0 1-7.95 3.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M41.05 44.3c6.214 0 11.25-5.037 11.25-11.25S47.265 21.8 41.05 21.8c-6.212 0-11.25 5.037-11.25 11.25S34.839 44.3 41.05 44.3"
  })));
};
export default SvgMagnifyingGlassDocument;